import {
  setCalendarSync as _setCalendarSync,
  SetCalendarSyncOptions,
} from '@griply/services';
import {
  arrayUnion,
  doc,
  getFirestore,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';

export type SetCalendarSyncInput = Pick<
  SetCalendarSyncOptions,
  | 'connectionId'
  | 'linkedItemId'
  | 'linkedItemType'
  | 'calendarId'
  | 'mode'
  | 'detailsVisibility'
>;

export const setCalendarSync = (input: SetCalendarSyncInput): void =>
  _setCalendarSync({
    ...input,
    doc,
    updateDoc,
    db: getFirestore(),
    serverTimestamp,
    arrayUnion,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.SetCalendarSync,
        error,
        docPath: `external-connections/${input.connectionId}`,
      }),
  });
